const features = [
  {
    icon: 'Real-Time Presence',
    title: 'She represents you in the room',
    body: "Jessica introduces herself, explains why she\u2019s there, and holds the meeting professionally on your behalf. The other participants know they\u2019re dealing with your delegate \u2014 not a recording tool.",
  },
  {
    icon: 'Live Briefing',
    title: 'You stay in the loop without being there',
    body: "Running summaries, flagged moments, and key decisions come to you as they happen. You always know what\u2019s unfolding \u2014 even when you\u2019re in your other meeting.",
  },
  {
    icon: 'Approval Routing',
    title: 'Decisions reach you instantly',
    body: "When someone in the meeting needs your sign-off, Jessica fires off a clean approval request directly to you. Reply yes or no. She handles the rest and communicates your answer to the room.",
  },
  {
    icon: 'On-Demand Dial-In',
    title: "You join when you\u2019re needed \u2014 not before",
    body: "Jessica monitors the meeting and brings you in at exactly the right moment. You walk into a call that\u2019s already alive, already briefed, already moving. No hold music. No dead air. No scrambling.",
  },
];

export default function FeaturesSection() {
  return (
    <section
      className="py-[110px] px-[60px] border-t border-[#1e1a18] bg-[#060606] max-md:px-6"
      style={{ fontFamily: "'Work Sans', sans-serif" }}
    >
      <div className="max-w-[1080px] mx-auto">
        <span className="block text-[11px] font-bold tracking-[0.22em] text-[#d43742] uppercase mb-7">
          What Jessica Does
        </span>
        <h2
          className="font-black text-[#faf9f7] leading-[0.95] tracking-[-0.01em]"
          style={{
            fontFamily: "'Big Shoulders Display', sans-serif",
            fontSize: 'clamp(42px, 6vw, 80px)',
          }}
        >
          Not a bot.
          <br />
          A delegate.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-[1px] bg-[#2a2422] mt-16">
          {features.map((f) => (
            <div
              key={f.icon}
              className="bg-[#0d0d0d] py-[44px] px-[40px] border-l-[3px] border-l-transparent hover:border-l-[#ac1218] transition-all duration-200 cursor-default"
            >
              <span className="block text-[11px] font-bold tracking-[0.14em] text-[#d43742] uppercase mb-4">
                {f.icon}
              </span>
              <div
                className="font-bold text-[#faf9f7] text-[30px] mb-[14px] leading-[1.1]"
                style={{ fontFamily: "'Big Shoulders Display', sans-serif" }}
              >
                {f.title}
              </div>
              <div className="text-[14px] font-light text-[#e0dbd5] leading-[1.7]">{f.body}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
